import axios from "axios";

export interface Flags {
    favorite?: boolean;
    disliked?: boolean;
    subscribed?: boolean;
}

const updateCheeseFlags = async (fromageId: number, flags: Flags): Promise<boolean> => {
    try {
      const apiUrl = import.meta.env.VITE_API_URL;
      
      const response = await axios.post(`${apiUrl}/fromages/${fromageId}/flags`, flags, {
        withCredentials: true,
      });
  
      if (response.status === 200) {
        return true;
      }
  
      return false;
    } catch (error: any) {
      // console.error('Failed to update flags:', error?.response?.data || error.message);
      return false;
    }
  };
  
  export default updateCheeseFlags;

